// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Css_AtomicTypes = require("bs-css/src/Css_AtomicTypes.bs.js");
var Particle_Color_Ds = require("./Particle_Color_Ds.bs.js");
var Particle_Color_Css = require("./Particle_Color_Css.bs.js");

var prefix = "--ads-";

function getThemeClassName(theme) {
  if (theme === "Dark") {
    return prefix + "dark";
  } else {
    return prefix + "light";
  }
}

function getVarName(t) {
  var varName = t === "Primary" ? "primary" : (
      t === "TextAlternative" ? "text-alternative" : (
          t === "SubHeaderBackground" ? "sub-header-background" : (
              t === "TeaserHover" ? "teaser-hover" : (
                  t === "Secondary" ? "secondary" : (
                      t === "EmptyTeaserBackground" ? "empty-teaser-background" : (
                          t === "TransparentBackground" ? "transparent-background" : (
                              t === "Background" ? "background" : (
                                  t === "Placeholder" ? "placeholder" : (
                                      t === "EmptyTeaserLogo" ? "empty-teaser-logo" : (
                                          t === "Geoblocking" ? "geoblocking" : (
                                              t === "SwitchInactiveCircle" ? "switch-inactive-circle" : (
                                                  t === "SwitchInactiveForeground" ? "switch-inactive-foreground" : (
                                                      t === "Text" ? "text" : (
                                                          t === "Divider" ? "divider" : "switch-inactive-background"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    );
  return prefix + varName;
}

function generateVariablesFromTheme(theme) {
  return Belt_Array.map([
              [
                getVarName("Background"),
                Particle_Color_Css.toCss(theme.secondary)
              ],
              [
                getVarName("Geoblocking"),
                Particle_Color_Css.toCss(Particle_Color_Ds.setAlpha(theme.secondary, 80))
              ],
              [
                getVarName("Primary"),
                Particle_Color_Css.toCss(theme.primary)
              ],
              [
                getVarName("Secondary"),
                Particle_Color_Css.toCss(theme.secondary)
              ],
              [
                getVarName("Divider"),
                Particle_Color_Css.toCss(theme.divider)
              ],
              [
                getVarName("Placeholder"),
                Particle_Color_Css.toCss(Particle_Color_Ds.setAlpha(theme.primary, 10))
              ],
              [
                getVarName("EmptyTeaserBackground"),
                Particle_Color_Css.toCss(theme.emptyTeaserBackground)
              ],
              [
                getVarName("EmptyTeaserLogo"),
                Particle_Color_Css.toCss(theme.emptyTeaserLogo)
              ],
              [
                getVarName("TeaserHover"),
                Particle_Color_Css.toCss(theme.TeaserHover.background)
              ],
              [
                getVarName("Text"),
                Particle_Color_Css.toCss(theme.primary)
              ],
              [
                getVarName("TransparentBackground"),
                Particle_Color_Css.toCss(Particle_Color_Ds.setAlpha(theme.secondary, 0.1))
              ],
              [
                getVarName("SubHeaderBackground"),
                Particle_Color_Css.toCss(theme.subHeaderBackground)
              ],
              [
                getVarName("SwitchInactiveBackground"),
                Particle_Color_Css.toCss(theme.Switch.Inactive.background)
              ],
              [
                getVarName("SwitchInactiveForeground"),
                Particle_Color_Css.toCss(theme.Switch.Inactive.foreground)
              ],
              [
                getVarName("SwitchInactiveCircle"),
                Particle_Color_Css.toCss(theme.Switch.Inactive.circle)
              ],
              [
                getVarName("TextAlternative"),
                Particle_Color_Css.toCss(Particle_Color_Ds.setAlpha(theme.primary, 80))
              ]
            ], (function (param) {
                return [
                        param[0],
                        Css_AtomicTypes.Color.toString(param[1])
                      ];
              }));
}

function getThemeVariables(theme) {
  return generateVariablesFromTheme(theme === "Dark" ? Particle_Color_Ds.Dark : Particle_Color_Ds.Light);
}

var Var = {
  prefix: prefix,
  $$default: "Dark",
  getThemeClassName: getThemeClassName,
  getVarName: getVarName,
  generateVariablesFromTheme: generateVariablesFromTheme,
  getThemeVariables: getThemeVariables
};

function color(x) {
  if (x === "Divider" || x === "Text" || x === "SwitchInactiveForeground" || x === "SwitchInactiveCircle" || x === "Geoblocking" || x === "EmptyTeaserLogo" || x === "Placeholder" || x === "Background" || x === "TransparentBackground" || x === "EmptyTeaserBackground" || x === "Secondary" || x === "TeaserHover" || x === "SubHeaderBackground" || x === "TextAlternative" || x === "Primary" || x === "SwitchInactiveBackground") {
    return CssJs.$$var(getVarName(x));
  } else if (x === "CorporateMenu" || x === "CorporateBorder" || x === "CorporateMenuText" || x === "CorporateMenuIcon") {
    if (x === "CorporateMenuText") {
      return CssJs.hex("151515");
    } else if (x === "CorporateBorder") {
      return CssJs.hex("EEEEEE");
    } else if (x === "CorporateMenu") {
      return CssJs.hex("E7E7E9");
    } else {
      return CssJs.hex("727272");
    }
  } else if (x === "Black") {
    return CssJs.hex("000000");
  } else if (x === "Histoire" || x === "Culture" || x === "Voyage" || x === "Serie" || x === "Cinema" || x === "Actualite" || x === "Default" || x === "Concert" || x === "Science") {
    if (x === "Science") {
      return CssJs.hex("DB0A5B");
    } else if (x === "Concert") {
      return CssJs.hex("FF8BC4");
    } else if (x === "Default") {
      return CssJs.hex("FFFFFF");
    } else if (x === "Actualite") {
      return CssJs.hex("1978D4");
    } else if (x === "Cinema") {
      return CssJs.hex("979D9E");
    } else if (x === "Serie") {
      return CssJs.hex("00E1E2");
    } else if (x === "Voyage") {
      return CssJs.hex("26C281");
    } else if (x === "Culture") {
      return CssJs.hex("BF55EC");
    } else if (x === "Histoire") {
      return CssJs.hex("FBBA16");
    } else {
      return CssJs.hex("000000");
    }
  } else if (x === "ArteLight") {
    return CssJs.hex("FC8E73");
  } else if (x === "DarkGrey") {
    return CssJs.hex("262626");
  } else if (x === "White") {
    return CssJs.hex("FFFFFF");
  } else if (x === "AccountHeader") {
    return CssJs.hex("484848");
  } else if (x === "LightGrey") {
    return CssJs.hex("9B9B9B");
  } else if (x === "Facebook") {
    return CssJs.hex("4267B2");
  } else if (x === "DividerStatic") {
    return CssJs.hex("464646");
  } else if (x === "Twitter") {
    return CssJs.hex("1DA1F2");
  } else if (x === "Afp") {
    return CssJs.hex("0B76D8");
  } else if (x === "HoverGrey") {
    return CssJs.hex("D0D0D0");
  } else if (x === "Success") {
    return CssJs.hex("7CDB63");
  } else if (x === "Error") {
    return CssJs.hex("FF6C6C");
  } else if (x === "Transparent") {
    return CssJs.transparent;
  } else if (x === "LogoPlaceHolder") {
    return CssJs.hex("555555");
  } else if (x === "Arte") {
    return CssJs.hex("FA481C");
  } else if (x === "Outline") {
    return CssJs.hex("4D90FE");
  } else if (x === "Grey") {
    return CssJs.hex("333333");
  } else if (x === "MediumGrey") {
    return CssJs.hex("212121");
  } else if (x === "Header") {
    return CssJs.hex("151515");
  } else if (x === "Whatsapp") {
    return CssJs.hex("25D366");
  } else if (x === "LastChance") {
    return CssJs.hex("9F3166");
  } else if (x === "MostRecent") {
    return CssJs.hex("4C336B");
  } else if (x === "AudioDescription") {
    return CssJs.hex("016B79");
  } else if (x === "Emissions") {
    return CssJs.hex("8D5515");
  } else {
    return CssJs.hex("274A39");
  }
}

function varColorsToCss(colors) {
  return Belt_Array.map(colors, (function (param) {
                return CssJs.unsafe(param[0], param[1]);
              }));
}

var Css = {
  color: color,
  varColorsToCss: varColorsToCss
};

exports.Var = Var;
exports.Css = Css;
/* CssJs Not a pure module */
